import ApiService from './ApiService'

export default class SafaricomOTPService {
    apiService

    constructor(token) {
        this.apiService = new ApiService(process.env.VUE_APP_SAFARICOM_API)
        this.apiService.setAccessToken(token)
    }

    async prompt(msisdn) {
        console.log('requesting otp token', msisdn)

        return this.apiService
            .post('/otp/generate', {
                msisdn,
            })
            .then((response) => response)
    }

    async validate({ msisdn, otp, guid, timestamp }) {
        return this.apiService
            .post('/otp/validate', {
                msisdn,
                otp,
                guid,
                timestamp,
            })
            .then((response) => response)
    }
}
